import React from "react";

export default function Discount() {
  return <div>Discount</div>;
}
